// Transient hover preview for the export frame overlay.
// Set true while the user hovers the export button so the frame is shown
// as a peek without committing it to scene state.

import {useSyncExternalStore} from 'react'

let preview = false
const listeners = new Set<() => void>()

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const notify = () => {
  listeners.forEach((l) => l())
}

export const setExportFramePreview = (value: boolean) => {
  if (preview === value) return
  preview = value
  notify()
}

export const getExportFramePreview = (): boolean => preview

export const useExportFramePreview = (): boolean =>
  useSyncExternalStore(subscribe, getExportFramePreview, getExportFramePreview)
